import React from 'react';
import './styles/showcase.css';

// Import billeder
import byggerietsPC from '../images/showcase/byggeriets-pc.webp';
import cbsPC from '../images/showcase/CBS-PC.webp';
import gislingeMobil from '../images/showcase/gislinge-mobil.webp';
import louiseMobil from '../images/showcase/louise-mobil.webp';

const ShowCase = () => {
  const cases = [
    {
      id: 1,
      title: "Byggeriets Digitale Transformation",
      image: byggerietsPC,
      description: "Moderne hjemmeside for byggeindustrien med fokus på professionel præsentation og brugervenlig navigation.",
      tags: ["Webdesign", "Responsiv", "Moderne"]
    },
    {
      id: 2,
      title: "CBS Business Solutions",
      image: cbsPC,
      description: "Professionel corporate website med avanceret funktionalitet og moderne design til erhvervskunder.",
      tags: ["Corporate", "B2B", "SEO"]
    },
    {
      id: 3,
      title: "Gislinge Mobile App",
      image: gislingeMobil,
      description: "Mobiloptimeret løsning med fokus på hurtig indlæsning og intuitiv brugeroplevelse på alle enheder.",
      tags: ["Mobile First", "PWA", "Performance"]
    },
    {
      id: 4,
      title: "Louise Portfolio",
      image: louiseMobil,
      description: "Kreativt portfolio website der fremhæver kunstnerisk arbejde med elegant design og smooth animationer.",
      tags: ["Portfolio", "Creative", "Animationer"]
    }
  ];

  return (
    <section className="showcase">
      <div className="showcase-grid">
        {cases.map((caseItem) => (
          <div key={caseItem.id} className="showcase-item">
            <div className="showcase-image-large">
              <img 
                src={caseItem.image} 
                alt={caseItem.title}
                loading="lazy"
                decoding="async"
              />
              <div className="showcase-overlay">
                <div className="showcase-overlay-content">
                  <h3 className="showcase-title-overlay">{caseItem.title}</h3>
                  <div className="showcase-tags-overlay">
                    {caseItem.tags.map((tag, index) => (
                      <span key={index} className="showcase-tag-overlay">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="showcase-content-minimal">
              <p className="showcase-description-minimal">{caseItem.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShowCase;

